import ReactApp from './Bootstrapper';

export default new ReactApp();
